import * as Label from '@radix-ui/react-label'
import { styled } from '@/styles/stitches.config'

export const StyledLabel = styled(Label.Root, {
  textTransform: 'uppercase',
  fontWeight: '600',
  fontSize: '0.75rem',
  letterSpacing: '0.7px',
})
